import axiosInstance from "../../../Utils/axios"

export const getUser = ({ rowsPerPage, pageNo }) =>
  axiosInstance.get(
    `api/users-list?offset=0&limit=${rowsPerPage}&page=${pageNo}&ordering=-id`,
  )

export const getPrevious = (previous) => axiosInstance.get(previous)

export const getNext = (next) => axiosInstance.get(next)

export const getPageUser = (number, rowsPerPage) =>
  axiosInstance.get(
    `api/users-list?offset=0&limit=${rowsPerPage}&page=${number}&ordering=-id`,
  )

export const createUser = (body) => axiosInstance.post("api/signup", body)

export const deleteUser = (id) => axiosInstance.delete(`api/users/${id}`)

export const handleSearch = ({ search, rowsPerPage }) =>
  axiosInstance.get(
    `api/users-list?offset=0&limit=${rowsPerPage}&search=${search}&ordering=-id`,
  )
